import { protect } from '@ctsu/loader';
import OpenRaveSetup from './Pages/OpenRave';
import RegulatorySetup from './Pages/Regulatory';
import ProtocolSetup from './Pages/Browser';
import { withNotificationContainer } from './components/notification';
import ProtectionElements from './helpers/ProtectionElement';

const protcolSetupRoutes = [
  {
    path: '/protocol-setup/browser',
    name: 'Setup',
    component: protect(withNotificationContainer(ProtocolSetup)),
    isExact: false,
    shortName: 'Setup',
    permission: ProtectionElements.BROWSER,
    showInMenu: true,
    helpContext: "ProtocolSetupBrowser"
  },
  {
    path: `/protocol-setup/open-rave/:rqNum`,
    name: 'OPEN Rave Setup',
    component: protect(withNotificationContainer(OpenRaveSetup)),
    showInMenu: false,
    permission: ProtectionElements.OPEN_REQUEST,
    helpContext: "OPEN_RaveRequest"
  },
  {
    path: `/protocol-setup/regulatory/:rqNum`,
    name: 'Regulatory Setup',
    component: protect(withNotificationContainer(RegulatorySetup)),
    showInMenu: false,
    permission: ProtectionElements.REGULATORY_REQUEST,
    helpContext: "RegulatoryRequest"
  },
  {
    path: `/protocol-setup/open-rave`,
    name: 'OPEN Rave Setup',
    component: protect(withNotificationContainer(OpenRaveSetup)),
    showInMenu: false,
    permission: ProtectionElements.OPEN_REQUEST,
    helpContext: "OPEN_RaveRequest"
  },
  {
    path: `/protocol-setup/regulatory`,
    name: 'Regulatory Setup',
    component: protect(withNotificationContainer(RegulatorySetup)),
    showInMenu: false,
    permission: ProtectionElements.REGULATORY_REQUEST,
    helpContext: "RegulatoryRequest"
  }
];

export default protcolSetupRoutes;